import { useTranslation } from 'react-i18next';

import { ComingSoon } from '../components/ComingSoon';
import { PortfolioPageLayout } from './components/PortfolioPageLayout';

export const PortfolioInvestmentsPage = () => {
  const { t } = useTranslation();

  return (
    <PortfolioPageLayout title={t('navbar.investments')}>
      <ComingSoon />
    </PortfolioPageLayout>
  );
};
